import { createStore } from "./store.ts";

/** What the browser remembers about the user between tabs. IT CONFERS NOTHING — it is an email, a sub-org id
 *  and an address. The two credentials that DO confer something are the Turnkey session (inside the SDK's own
 *  keystore, non-extractable, the only thing that can sign) and the API bearer (per-tab `sessionStorage`).
 *  Conflating any two of the three is a custody error, which is why this store holds only the inert one. */
export interface WalletRecord {
  email: string;
  subOrgId: string;
  address: string;
}

// IN MEMORY ONLY. This store never touches `localStorage`: `src/auth/wallet.ts` is the one reader and writer of
// `localStorage["kinetiq.v3.wallet"]`, and it calls `setWallet()` here. Two files persisting one record is the
// drift that makes sign-out clear the copy nobody is reading.
export const walletStore = createStore<WalletRecord | null>(null);

export function setWallet(record: WalletRecord | null): void {
  walletStore.set(record);
}

// DELIBERATELY ABSENT: any persisted `signable` / `verified` boolean. Whether the browser can sign is answered
// by a REAL keystore probe (`auth/turnkey.ts` `hasSession()`), never by a flag — a flag written at sign-in
// survives session expiry, a cleared keystore and any deploy that changed how sessions are stored, and the
// symptom is a Buy button that fails identically on every press.
